import React from "react";

interface Props {
  onSelect: (_: string) => void;
}

const TAG_COLOR_OPTIONS = ["#D3EEF3", "#26B5CE", "#0F7488", "#4CB782", "#0F783C", "#F2C94C", "#5A450D", "#F2994A", "#DB6E1F", "#EB5757", "#C52828", "#5E6AD2"];
export const TAG_DEFAULT_COLOR = "#F2C94C";

export default function TagColorPicker({ onSelect }: Props) {
  return (
    <div className="shadow bg-white grid grid-cols-4 border border-cool-gray-100 w-40">
      {TAG_COLOR_OPTIONS.map((colorOption, index) => (
        <div className="hover:bg-gray-100 col-span-1 p-3" onClick={() => onSelect(colorOption)} key={index}>
          <div key={index} className="rounded-full w-3 h-3" style={{ background: colorOption }} />
        </div>
      ))}
    </div>
  );
}
